import { render, staticRenderFns } from "./U.Pattern.vue?vue&type=template&id=fffc77f2&"
import script from "./U.Pattern.vue?vue&type=script&lang=js&"
export * from "./U.Pattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports